import React, { useEffect, useState } from "react";
import "./css/ourschool.css";
import NobleSidebar from "./NobleSidebar";
import Loader from "./Loader";

const OurSchool = () => {
  const [schooldata, setSchoolData] = useState();
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);
  const baseUrl = process.env.REACT_APP_BASE_URL;
  const school = process.env.REACT_APP_SCHOOL;

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await fetch(
          `${baseUrl}/${school}/items/ourschool?fields=*.*`
        );
        const data = await response.json();
        setSchoolData(data?.data?.[0]);
      } catch (error) {
        console.log("Error fetching school message:", error);
        setError("Failed to load data. Please try again later.");
      } finally {
        setIsLoading(false);
      }
    };

    fetchData();
  }, [baseUrl, school]);

  if (isLoading)
    return (
      <div className="h-[90vh] w-full flex items-center justify-center bg-white">
        <Loader />
      </div>
    );
  if (error) return <div className="text-red-600 text-center">{error}</div>;

  return (
    <>
      <div className="container-fluid p-0 mt-2">
        <div className="container-fluid d-flex latest_card_box_ad p-0">
          <div className="ourschooleft px-5 text-left">
            <h4
              className="kalur text-center"
              style={{ color: "black", fontWeight: "bold" }}
            >
              Our School
            </h4>
            <b>
              <p>
                {schooldata ? (
                  schooldata?.school_name
                ) : (
                  <em>Maharishi Dayanand School.</em>
                )}
              </p>
            </b>
            <b>
              <div>
                {schooldata ? (
                  // schooldata?.description
                  <h2
                    dangerouslySetInnerHTML={{
                      __html: schooldata?.oursection,
                    }}
                  ></h2>
                ) : (
                  <em>
                    Maharishi's Dayanand School was founded by Late Shri
                    K.L.Sahu Double M.A , LLB. Etc. and an Retired A.D.I.S (
                    Education Department ) . School established in 1996 and it
                    is run by Gyanoday samiti 1973 . We, Maharishi Dayanand
                    School, understand that each child is a distinct individual
                    who needs to be nurtured in order to grow into a mature and
                    responsible citizen. Our academic infrastructure along with
                    a wide range of co-curricular activities help our students
                    in the all round personality development. We have a strong
                    team of motivated teachers who are always ready to accept
                    challenges of developing the potential of each and every
                    student. Keeping in view the ideas of democracy and our
                    ancient culture, Maharishi Dayanand School strives to
                    provide a system of education most suited to the needs of
                    our society today. Stress on innovative methods of teaching
                    , opportunities for shouldering responsibilities during
                    school life, constant participation in sports and
                    co-curricular activities lend meaning to the school life.
                    Thus, the end product is the harmonious, all round developed
                    personality of our students poised on the threshold of life.
                  </em>
                )}
              </div>
            </b>
            {/* <h5>Maharishi Dayanand School is proud to offer:</h5> */}
            {/* <ul className="px-3">
              <li>Maharishi Dayanand School is proud to offer:</li>
              <li>A great Indian environment for growing and learning</li>
              {/* <li>Indian Studies, CBSC, and programs</li> */}

              {/* <li>and much more…</li> */}
            {/* </ul> */} 
            {/* <p>
              We encourage all community members to discover the possibilities
              at the Maharishi Dayanand School!
            </p> */}
          </div>

          <div className="ourschoolright p-4">
            <NobleSidebar />
          </div>
        </div>
      </div>
    </>
  );
};

export default OurSchool;
